import { render, staticRenderFns } from "./tableCommon.vue?vue&type=template&id=2032a961"
import script from "./tableCommon.vue?vue&type=script&lang=js"
export * from "./tableCommon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports